import { MDBAlert, MDBBtn, MDBIcon } from "mdbreact"
import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Container, Form, Input, Label, Media, Row } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"

export default class EscolaridadFormulario extends React.Component {
    
    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);

        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
                nombre: ''
            },
            colapsar: true,
            camposRequeridos: []
        };
    }

    componentDidMount() {
        
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: value }
        }));
    }
    
    almacenarRegistro = () => {
        if (this.datosRegistroValidos()) {
            const registro = this.state.registro
            if (registro.id !== undefined && registro.id !== null) {
                this.apiRest.put('/escolaridad/' + registro.id, registro).then(resultado => {
                    if (resultado.exitoso) {
                        toastr.success('Datos almacenados exitosamente!');
                        this.props.history.replace('/escolaridadListado');
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            } else {
                this.apiRest.post('/escolaridad', registro).then(resultado => {
                    if (resultado.exitoso) {
                        toastr.success('Datos almacenados exitosamente!');
                        this.setState({ registro: resultado.data });
                        this.props.history.replace('/escolaridadListado');
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            }
        }
    }

    datosRegistroValidos() {
        const { registro, camposRequeridos } = this.state;

        let existenErrores = false
        if (!_valid(registro.nombre)) {
            camposRequeridos.push("Nombre");
            existenErrores = true;
        }

        if (existenErrores) {
            this.setState({ camposRequeridos: camposRequeridos });
            setTimeout(() => this.setState({ camposRequeridos: [] }), 3000);
        }

        return !existenErrores;
    }

    render() {
        const { registro, colapsar, camposRequeridos } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Datos" breadcrumbItem="Escolaridad" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark" to="#">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Escolaridad</h5>
                                                        <p className="text-muted text-truncate mb-0">Por favor, proporciona los datos.</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <div className="p-4 border-top">
                                                <Form>
                                                    <div>
                                                        <Row>
                                                            <Col lg={12}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="name" className="form-label">
                                                                        Nombre
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.nombre}
                                                                        onChange={this.actualizarValores}
                                                                        name="nombre"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresar nombre"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    &nbsp;
                                                    <Row>
                                                        {_valid(camposRequeridos) && camposRequeridos.map((campo, index) => <MDBAlert key={index} color="danger"><strong>{campo}</strong> es requerido.</MDBAlert>)}
                                                    </Row>
                                                </Form>
                                            </div>
                                            <Row>
                                                <Col lg={12} className="text-end">
                                                    <MDBBtn className="waves-effect"color="danger" onClick={() => { this.props.history.replace('/escolaridadListado') }}>
                                                        <MDBIcon icon="fas fa-arrow-left" />{' '}
                                                        Regresar
                                                    </MDBBtn>
                                                    {' '}
                                                    <MDBBtn className="waves-effect"color="success" onClick={() => this.almacenarRegistro()}>
                                                        <MDBIcon icon="fas fa-user-check" /> {' '}
                                                        Listo
                                                    </MDBBtn>
                                                </Col>
                                            </Row>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}